/** Chatbot movil
 * 
*/
function chatbotMobile() {
    let screenSize = window.innerWidth;

    if (screenSize < 544) {
        $('#embeddedMessagingConversationButton').css({
            'right': '-100vh',
        });

        $('.show-chatbot').on('click', function(event) {
            event.preventDefault();
            event.stopPropagation();
            $('#embeddedMessagingConversationButton').css({
                'right': '30px',
            });
        })        
    }
}

/**
 * Check if the resolution is for a mobile device.
 * @returns {boolean} True if the resolution is mobile, false otherwise.
 */
function isMobile() {
    return window.matchMedia("(max-width: 543px)").matches;
}

$(document).ready(function() {
    $('.icon-menu-mobile').on('click', chatbotMobile);

    /**
     * Adjusts the position of the embedded messaging button and frame based on the presence
     * and value of the `isPdp` element and the device type (mobile or desktop).
     * 
     * If the `isPdp` element has a value of 'true' and the device is mobile, both the button
     * and the frame will have their bottom style set to '9rem'. Otherwise, their bottom style
     * will be set to '25px'.
     */
    function adjustChatbotPositionPDP() {
        let pdpElement = document.getElementById('isPdp');
        let cartElement = document.getElementById('isCart');
        if (!pdpElement) {
            pdpElement = cartElement;
        }
        if (isMobile()) {
            if (pdpElement && (pdpElement.value == true || pdpElement.value == 'true')) {
                document.body.classList.add('is-pdp');
            } else {
                document.body.classList.remove('is-pdp');
            }
        } else {
            document.body.classList.remove('is-pdp');
        }
    }

    if (isMobile()) {
        setTimeout(adjustChatbotPositionPDP, 1500);
    }

    setTimeout(() => {
        $('.embeddedMessagingConversationButton, .embeddedMessagingFrame').addClass("load");
    }, 1500);

    $(window).resize(adjustChatbotPositionPDP);  
});
